import { useContext } from 'react';
import { DebugModeContext } from '../context/debug-mode-context';

const useDebugModeContext = () => {
  const context = useContext(DebugModeContext);
  if (!context) {
    throw new Error('useDebugModeContext must be used within a DebugModeContext');
  }
  return context;
};
export default useDebugModeContext;
